<template>
  <div>
    <vxe-modal
      v-model="QuestionnaireObjectSetDialogVisible"
      :before-hide-method="handleClose"
      width="40%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>{{title}}</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <!-- 表达区域-->
          <div class="switch-display border-all">
            <!-- 表单区域-->
            <div class="switch-content">
              <el-form size="small">
                <div class="formtable">
                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="20">
                      <div class="grid-content bg-purple">
                        <el-form-item label="设定维度:">
                          <el-radio-group v-model="range" @change="selectRang">
                            <el-radio label="0">公司</el-radio>
                            <el-radio label="1">部门</el-radio>
                            <el-radio label="2">员工</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="20">
                      <div class="grid-content bg-purple">
                        <el-form-item>
                          <vxe-table
                            :data="DataList"
                            round
                            border
                            height="388"
                            class="mytable-scrollbar"
                            style="width: 100%"
                            :highlight-current-row="true"
                            ref="multipleTable"
                            row-id="id"
                            highlight-hover-row
                            highlight-hover-column
                            highlight-current-column
                            show-overflow="tooltip"
                            :tooltip-config="{ enterable: true }"
                            empty-text="没有更多数据了！"
                            resizable
                            stripe
                            @current-change="currentChangeEvent"
                            @checkbox-all="selectAllChangeEvent"
                            @checkbox-change="handleSelectionChange"
                          >
                            <vxe-table-column
                              fixed="left"
                              type="checkbox"
                              title="全选"
                              width="80"
                            ></vxe-table-column>
                            <vxe-table-column
                              fixed="left"
                              type="seq"
                              width="60"
                              title="序号"
                              align="center"
                            ></vxe-table-column>
                            <vxe-table-column
                              key="id"
                              field="id"
                              title="id"
                              align="center"
                              v-if="false"
                              show-overflow-tooltip
                            />
                            <vxe-table-column
                              key="label"
                              field="label"
                              :title="getlabletitle()"
                              align="center"
                              show-overflow-tooltip
                            />
                          </vxe-table>

                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </div>
        </div>
        <div class="option">
          <div>
            <el-button @click="handleCancel">
              <span>关闭</span>
            </el-button>
            <el-button @click="handleConfirm">
              <span>确定</span>
            </el-button>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import {
  SelectCompanyById,
  ModifyCompany,
  AddCompany,
} from "@api/Company/ApiCompany";

import { getUserInfo } from "@/util/authority";

import { GetDataUserListByPageQuery } from "../../api/Company/ApiUser";

import { GetDataByUserCode } from "../../api/Company/ApiCompany";

import {GetQuestionObjectDataById} from "../../api/Questionnaire"

export default {
  name: "QuestionnaireObjectSet",
  props: {
    QuestionnaireObjectSetDialogVisible: {
      type: Boolean,
      default: false,
    },
    parentcode: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "问卷调研对象设置",
    }
  },
  data() {
    return {
      SelectData: {},
      IsReadonly: false,
      IsShowConfirm: true,
      IsReadonlyCode: true,
      OpStatus: "Detail",
      range: "0",//选择的维度
      CompanyData: [],
      DepartmentData: [],
      UserData: [],
      DataList: [],
      CheckedIds:[],//编辑的时候选中用
    };
  },
  created() {},
  mounted() {},
  methods: {
    getlabletitle(){
      let title = "姓名";
      switch(this.range) {
        case "0":
          title = "公司名称";
          break;
        case "1":
          title = "部门名称";
          break;
        case "2":
          title = "姓名";
          break;
      }
      return title;
    },
    selectRang(val) {
      //debugger
      console.log("子组件接受父组件的传参parentcode："+this.parentcode)
      var _this = this;

      _this.range = val;
      _this.DataList = [];
      var userInfo = getUserInfo();

      if (val == "1") {
        //部门
        if (_this.DepartmentData.length == 0) {
          _this.loadData(userInfo.CodeID);
        } else _this.intoData();
      } else if (val == "2") {
        //员工
        if (_this.UserData.length == 0) {
          _this.loadData(userInfo.CodeID);
        } else _this.intoData();
      } else {
        //公司
        if (_this.CompanyData.length == 0) {
          GetDataUserListByPageQuery({
            queryModel: {
              code: userInfo.CodeID,
            },
            pageindex: 1,
            PageSize: 1,
          }).then((res) => {
            _this.CompanyData = res.entities;

            _this.intoData();
          });
        } else _this.intoData();
      }
    },
    loadDefaulData(range,key){
      var _this = this
      _this.CheckedIds=[]
      if(range=="1"||range=="2"){

        GetQuestionObjectDataById(key).then(res=>{

          if(res&&res.length>0){
            var ids=[]
            res.forEach(x=>{
              if(range=="1")ids.push(x.departmentId)
              if(range=="2")ids.push(x.userId)
            })
            _this.CheckedIds=ids
          }
          _this.selectRang(range)
        })
      }else{
        _this.selectRang(range)
      }
    },
    //默认选中
    defaultChecked(){
      // debugger
      var _this= this
      let table = _this.$refs.multipleTable;
      if(_this.CheckedIds.length>0){
        setTimeout(() => {
          for (var i=0;i<_this.CheckedIds.length;i++){
            table.setCheckboxRow(table.getRowById(_this.CheckedIds[i]), true)
          }
        }, 100);
      }
      if(_this.range=="0"){
        setTimeout(() => {
          table.setCheckboxRow(table.getRowById(_this.DataList[0].id), true)
        }, 100);
      }
    },
    intoData() {
      var _this = this;
      var DataList=[];
      switch (_this.range) {
        case "0":
          _this.CompanyData.forEach((x) => {
            DataList.push({
              id: x.companyId,
              label: x.companyName,
            });
          });
          break;
        case "1":
          _this.DepartmentData.forEach((x) => {
            DataList.push({
              id: x.id,
              label: x.name,
            });
          });
          break;
        case "2":
          _this.UserData.forEach((x) => {
            DataList.push({
              id: x.id,
              label: x.name,
            });
          });
          break;
      }
      _this.DataList=[]
      _this.DataList=DataList
      _this.defaultChecked()
    },
    loadData(code) {
      var _this = this;
      GetDataByUserCode(code)
        .then((x) => {
          _this.DepartmentData = x.departments;
          _this.UserData = x.users;
          _this.intoData();
        })
        .catch((x) => {
          _this.$message.error(x.message);
        });
    },

    handleSelect(item) {
      console.log(item);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    GetNameByDm(vaule) {
      var newArr = arr.filter((item) => item.prop == vaule);
      return newArr[0].label;
    },

    handleClose() {
      this.$emit("handleCancel");
    },
    handleCancel() {
      this.$emit("handleCancel");
    },
    handleConfirm() {
      var ids=[];
      this.$refs.multipleTable.getCheckboxRecords(true).forEach(x=>{
        ids.push(x.id)
      })

      if(ids.length==0){
        this.$message.error("请选择维度对象")
        return;
      }
      this.$emit("handleConfirm",{
        range:this.range,
        ids:ids
      });

    },
    validate() {
      if (!this.SelectData.code || this.SelectData.code == "") {
        this.$message.error("代码是必须的!");
        return false;
      }
      if (!this.SelectData.name || this.SelectData.name == "") {
        this.$message.error("名称是必须的!");
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped >
.select-items {
  position: relative;
  display: flex;
}

.select-item {
  height: 50px;
  flex: 33.33%;
  display: flex;
  margin: 0 10px;
}
.item-lab {
  flex: 25%;
  line-height: 50px;
  display: flex;
  position: relative;
}

.item-input {
  flex: 75%;
}

.item-lab > label {
  align-items: flex-end;
  position: absolute;
  right: 5px;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
::v-deep .el-form-item__label {
  width: 80px;
  padding: 0;
  text-align: left;
}
.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}
</style>
